import React from "react";

//function Skill({ progress, isVisible }) {
function Skill({ progress }) {
  const { title, description } = progress;
  //const { title, description, percantage, progressColor } = progress;
  //const winWidth = window.innerWidth;
  // const progressQuery = () => {
  //   if (winWidth && winWidth > 767) {
  //     return (
  //       <div
  //         className="progress-bar data-background"
  //         style={
  //           isVisible
  //             ? {
  //                 width: `${percantage}%`,
  //                 background: progressColor,
  //               }
  //             : { width: 0, background: progressColor }
  //         }
  //       ></div>
  //     );
  //   }
  //   return (
  //     <div
  //       className="progress-bar data-background"
  //       style={{
  //         width: `${percantage}%`,
  //         background: progressColor,
  //       }}
  //     ></div>
  //   );
  // };
  return (
    <div className="skill-item">
      <div className="skill-info clearfix">
        <h4 className="float-left mb-2 mt-0">{title}</h4>
        <p className="float-left mb-3 mt-0">{description}</p>
        {/* <span className="float-right">{percantage}%</span> */}
      </div>
      {/* <div className="progress">{progressQuery()}</div> */}
    </div>
  );
}

export default Skill;
